function HeaderCtaButtons({ children }) {
  return (
    <div className="header__ctabuttons" key="headerCtabuttons">
      {children}
    </div>
  );
}
export default HeaderCtaButtons;
